<template>
  <div
    class="teaser-video"
    @click="handleVideoClick"
  >
    <div class="content">
      <video
        ref="video"
        :poster="posterframeUrl"
        @ended="handleVideoEnded"
      >
        <source
          :src="videoUrl"
          type="video/mp4"
        >
      </video>
      <div
        v-if="paused"
        class="button-play"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'TeaserVideo',
  props: {
    posterframe: {
      type: String,
      required: true,
    },
    video: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      paused: true,
    };
  },
  computed: {
    videoUrl() {
      return `${this.$store.state.basePath}${this.video}`;
    },
    posterframeUrl() {
      return `${this.$store.state.basePath}${this.posterframe}`;
    },
  },
  methods: {
    handleVideoClick() {
      if (this.$refs.video.paused) {
        this.$refs.video.play();
        this.paused = false;
      } else {
        this.$refs.video.pause();
        this.paused = true;
      }
    },
    handleVideoEnded() {
      this.$refs.video.load();
      this.paused = true;
    },
  },

};

</script>
<style lang="stylus" scoped>

.teaser-video {
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.content {
  cursor: pointer;
  width: 100%;
  max-width: 564px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: black;
  overflow: hidden;
}
video {
  width: 100%;
  height: auto;
}
.button-play {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -40px;
  margin-top: -40px;
  width: 80px;
  height: 80px;
  background: #fff;
  border-radius: 50%;
  &:after {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -8px;
    margin-top: -12px;
    display: block;
    content: '';
    width: 0;
    height: 0;
    border-top: 12px solid transparent;
    border-bottom: 12px solid transparent;
    border-left: 16px solid black;
  }
}
</style>
